
export const getUsers = ({ users }) => users;
export const getUserForm = ({ user }) => user;
export const getNewUser= ({ newUser }) => newUser;
export const getUserPerfil = ({ userPerfil }) => userPerfil;
export const getPerfilUser = ({ perfilUser }) => perfilUser;
export const getApisUser = ({ apisUser }) => apisUser;
export const getDadoGerais = ({ dadoGerais }) => dadoGerais;
export const getStatusLabel = ({ statusLabel }) => statusLabel;
export const getStatusColor = ({ statusColor }) => statusColor;
export const getPerfil = ({ perfil }) => perfil;
export const getApisConsumed = ({ apisConsumed }) => apisConsumed;
export const getAmbience = ({ ambience }) => ambience;
export const getHeaderApis = ({ headerApis }) => headerApis;
export const getHeaderUsres = ({ headerUsres }) => headerUsres;
export const getLabelsFisica = ({ labelsFisica }) => labelsFisica;
export const getLabelsJuridica = ({ labelsJuridica }) => labelsJuridica;
export const getNewewUserLabel = ({ newUserLabel }) => newUserLabel;
export const getAvatars = ({ avatres }) => avatres;

export const getBackupUser = ({ backupUser }) => backupUser;
